export const fetchTiles = 'fetchTiles';
export const cancelRequest = 'cancelRequest';
export const processSearch = 'processSearch';
export const createFilterParams = 'createFilterParams';
